var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconConnect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_8109)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_8109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 25.0957C14.1995 25.0957 13.5483 25.7469 13.5483 26.5473C13.5483 27.3477 14.1995 27.9989 15 27.9989C15.8004 27.9989 16.4516 27.3477 16.4516 26.5473C16.4516 25.7469 15.8004 25.0957 15 25.0957ZM15 27.0312C14.7331 27.0312 14.5161 26.8141 14.5161 26.5473C14.5161 26.2805 14.7331 26.0634 15 26.0634C15.2668 26.0634 15.4838 26.2805 15.4838 26.5473C15.4838 26.8141 15.2668 27.0312 15 27.0312Z",
    fill: "#0095FF",
    stroke: "#0095FF",
    strokeWidth: 0.768
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 3.96878C15.2847 3.96878 15.5163 3.73723 15.5163 3.45265C15.5163 3.16807 15.2847 2.93652 15.0001 2.93652C14.7156 2.93652 14.484 3.16807 14.484 3.45265C14.484 3.73723 14.7156 3.96878 15.0001 3.96878Z",
    fill: "#0095FF",
    stroke: "#0095FF",
    strokeWidth: 0.768
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9619 5.93848H7.03819C6.77097 5.93848 6.55432 6.15512 6.55432 6.42235V23.5783C6.55432 23.8456 6.77097 24.0622 7.03819 24.0622H22.9619C23.2292 24.0622 23.4458 23.8456 23.4458 23.5783V6.42235C23.4458 6.15512 23.2292 5.93848 22.9619 5.93848ZM22.4781 23.0945H7.52206V6.90622H22.4781V23.0945Z",
    fill: "#0095FF",
    stroke: "#0095FF",
    strokeWidth: 0.768
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2581 0H7.74194C6.01981 0 4.61877 1.40103 4.61877 3.12316V26.8768C4.61877 28.599 6.01981 30 7.74194 30H22.2581C23.9802 30 25.3812 28.599 25.3812 26.8768V3.12316C25.3812 1.40103 23.9802 0 22.2581 0ZM24.4135 26.8768C24.4135 28.0654 23.4466 29.0323 22.2581 29.0323H7.74194C6.55342 29.0323 5.58652 28.0654 5.58652 26.8768V3.12316C5.58652 1.93465 6.55342 0.967742 7.74194 0.967742H22.2581C23.4466 0.967742 24.4135 1.93465 24.4135 3.12316V26.8768Z",
    fill: "#0095FF",
    stroke: "#0095FF",
    strokeWidth: 0.768
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 16.1436C17.0856 16.1436 18.7823 14.4469 18.7823 12.3614C18.7823 10.2758 17.0856 8.5791 15 8.5791C12.9145 8.5791 11.2178 10.2758 11.2178 12.3614C11.2178 14.4469 12.9145 16.1436 15 16.1436ZM15 9.54684C16.552 9.54684 17.8145 10.8094 17.8145 12.3614C17.8145 13.9133 16.552 15.1759 15 15.1759C13.4481 15.1759 12.1855 13.9133 12.1855 12.3614C12.1855 10.8094 13.4481 9.54684 15 9.54684Z",
    fill: "#0095FF",
    stroke: "#0095FF",
    strokeWidth: 0.768
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.92604 21.3851C10.1738 21.4854 10.4558 21.3659 10.5562 21.1182C11.2932 19.2981 13.0375 18.122 15 18.122C16.9625 18.122 18.7068 19.2981 19.4438 21.1182C19.52 21.3064 19.7011 21.4206 19.8924 21.4206C19.9529 21.4206 20.0144 21.4091 20.0739 21.3851C20.3216 21.2848 20.4411 21.0027 20.3408 20.7549C19.4551 18.5677 17.3587 17.1543 15 17.1543C12.6413 17.1543 10.5449 18.5676 9.65914 20.7549C9.55888 21.0027 9.67836 21.2848 9.92604 21.3851Z",
    fill: "#0095FF",
    stroke: "#0095FF",
    strokeWidth: 0.768
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_8109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_8109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConnect);
export default __webpack_public_path__ + "static/media/iconConnect.443e481268439d2f01933ebad963478a.svg";
export { ForwardRef as ReactComponent };